<template>
  <v-col cols="12" v-if="categoryWithProducts" class="text-center">
    <MobileMenu v-if="$vuetify.breakpoint.mobile"/>
    <span class="text-overline text-uppercase" :style="{color: color}">
      {{ categoryWithProducts.name }}
    </span>
    <v-divider :style="{borderColor:color}"/>
    <div class="arrowDown" :style="{borderTop: '6px solid ' + color}"></div>
    <v-row>
      <v-col cols="6" :sm="3"
             v-for="(product) in categoryWithProducts.products" :key="'product_'+product.id"
             class="pa-2">
        <ProductTileNew :product="product"/>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import Axios from '@/core/Axios';
import ProductTileNew from '@/components/Partials/ShopBody/ProductTileNew.vue';
import { translations } from '@/lang/translations';
import MobileMenu from '../Partials/TopBar/MobileMenu.vue';

export default {
  name: 'CategoryView',
  components: { ProductTileNew, MobileMenu },
  data() {
    return {
      axios: new Axios(),
      categoryWithProducts: null,
      color: '#0084cc',
    };
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    text() {
      return translations[this.$store.state.language];
    },
  },
  mounted() {
    if (this.$route.meta.link !== 'preorders') {
      this.getProductsByCategorySlug();
    } else {
      this.getPreorders();
    }
  },
  watch: {
    slug() {
      if (this.$route.meta.link !== 'preorders') {
        this.getProductsByCategorySlug();
      } else {
        this.getPreorders();
      }
    },
  },
  methods: {
    getPreorders() {
      this.axios.makeCall('GET', 'norbit/product/getpreorders')
        .then((response) => {
          if (response) {
            this.categoryWithProducts = {
              products: response,
              name: this.text.common.preorders,
            };
          }
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });
    },
    getProductsByCategorySlug() {
      this.axios.makeCall('GET', `norbit/product/${this.$route.meta.link}/${this.slug}`)
        .then((response) => {
          if (response) {
            this.categoryWithProducts = response;
          }
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });
    },
  },
};
</script>

<style scoped>
.arrowDown {
  width: 0;
  height: 0;
  margin-left: 49.5%;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
</style>
